
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/settings",
      function () {
        return require("private-next-pages/my-account/settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/settings"])
      });
    }
  